import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tab, TabList, TabPanel, TabPanels, Tabs } from '@carbon/react';
import { Launch, Printer } from '@carbon/react/icons';
import cx from 'clsx';

import { routes } from 'core/routing';
import BusinessUnitProgramBreakdown from 'features/dashboard/business-unit/BusinessUnitProgramBreakdown';
import DashboardOverview from 'features/dashboard/DashboardOverview';
import ProgramSummary from 'features/dashboard/site-wide/ProgramSummary';
import SiteChart from 'features/dashboard/site-wide/SiteChart';
import SiteProgramBreakdown from 'features/dashboard/site-wide/SiteProgramBreakdown';
import styles from 'theme/features/dashboard/dashboard.module.scss';

const Dashboard = ({ projectId, project, outputs, compact = false, isExport = false }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const navigate = useNavigate();

  const renderProgramTab = (component, headerComponent = null) => (
    <TabPanel className={styles['tab-panel']}>
      {headerComponent}
      <div className={cx(styles['dashboard-breakdown'], compact && styles['dashboard-breakdown--compact'])}>
        {component}
      </div>
    </TabPanel>
  );

  return (
    <div className={cx(styles.dashboard, compact && styles['dashboard--compact'])}>
      <DashboardOverview
        projectId={projectId}
        project={project}
        overview={outputs?.overview}
        isCompact={compact}
        isExport={isExport}
      />
      {!compact && <span />}
      <div className={styles['aside']}>
        {!compact && !isExport && (
          <div className={styles['program-header']}>
            <IconButton
              label="View Full Project Requirements"
              kind="ghost"
              size="sm"
              align="bottom-right"
              onClick={() => navigate(routes.exportProject(projectId))}
            >
              <Launch size={22} />
            </IconButton>
            <IconButton
              label="Print Preview"
              onClick={() => window.print()}
              className={styles['print-button']}
              kind="ghost"
              size="sm"
              align="bottom-right"
            >
              <Printer size={22} />
            </IconButton>
          </div>
        )}
        <Tabs selectedIndex={selectedTabIndex} onChange={({ selectedIndex }) => setSelectedTabIndex(selectedIndex)}>
          <TabList className={styles['tab-list']} aria-label="Dashboard breakdown">
            <Tab>Site-wide</Tab>
            <Tab disabled={!outputs}>By Business Unit</Tab>
            <Tab disabled={!outputs} />
          </TabList>
          <TabPanels>
            {renderProgramTab(
              <>
                <SiteProgramBreakdown project={project} overview={outputs?.overview} isCompact={compact} />
                <SiteChart projectId={projectId} overview={outputs?.overview} isCompact={compact} isExport={isExport} />
              </>,
              <ProgramSummary breakdown={outputs?.units} measurementSystem={project?.details.measurementSystem} />
            )}
            {renderProgramTab(
              <BusinessUnitProgramBreakdown
                breakdown={outputs?.units}
                measurementSystem={project?.details.measurementSystem}
                isCompact={compact}
              />
            )}
          </TabPanels>
        </Tabs>
      </div>
    </div>
  );
};

export default Dashboard;
